import { useEffect, useState, useContext, useMemo } from "react";
import { API } from "../../../API";
import { ShareAPI } from "../../../API";
import { narrativeActorsUrl } from "../../../utils/narrativeActors";
import { useTranslation } from 'react-i18next';
import { BreakdownsContext } from "./contexts/BreakdownsContext";
import { BreakdownsContainer } from "../../../components/BreakdownsContainer/BreakdownsContainer";
import { LoaderSmall } from "../../../components/LoaderSmall/LoaderSmall";
import styles from '../NarrativePage.module.scss';
import { showRequestError } from '../../../utils/requestError';
import { VerticalBarChart } from '../../../components/VerticalBarChart/VerticalBarChart';

const BAR_COLORS = ['#81A5F3', '#6994F1', '#5284EF', '#3B73ED', '#2459CA'];

const audienceSizeMap = {
  'very_small': [0, 1000],
  'small': [1000, 10000],
  'medium': [10000, 100000],
  'big': [100000, 500000],
  'very_big': [500000, 1000000000]
};


export const Audience = ({isShare, narrative, isClickable=true, title}) => {
  const { t } = useTranslation();
  const [audience, setAudience] = useState(null);
  const {openModal, setAudienceFilter, setCurrentWidgetName, setModalTitle} = useContext(BreakdownsContext);
  const api = isShare ? ShareAPI : API;
  const bucketNameMap = useMemo(() => ({
    'very_small': t('Very small (< 1k)'),
    'small': t('Small (1k - 10k)'),
    'medium': t('Medium (10k - 100k)'),
    'big': t('Big (100k - 500k)'),
    'very_big': t('Very big (> 500k)')
  }), [t]);

  const getAudience = () => {
    const urlParams = new URLSearchParams();
    urlParams.set('widget_name', `audience_breakdown`);
    const url = narrativeActorsUrl(narrative.id, 'audience-sizes', urlParams);
    api.fetch('GET', url).then(
      data => setAudience(data)
    ).catch(e => showRequestError(e, t('Audience size')))
  }

  useEffect(() => {
    getAudience()
  }, [narrative.id])

  const chartItems = useMemo(
    () =>
      (audience?.objects ?? []).map((item, index) => ({
        bucket: item.bucket,
        name: bucketNameMap[item.bucket] ?? item.bucket,
        value: item.count,
        color: BAR_COLORS[index % BAR_COLORS.length],
      })),
    [audience, bucketNameMap],
  );

  const onSelect = (index) => {
    const item = index === null ? undefined : chartItems[index];
    if (!item) return;
    setAudienceFilter(audienceSizeMap[item.bucket]);
    setCurrentWidgetName('audience_breakdown');
    setModalTitle(item.name);
    openModal();
  };

  return(
    <BreakdownsContainer
      title={title ? title : 'Audience size'}
      onClick={() => openModal()}
      details={false}
    >
      {audience ? (audience.objects?.length > 0
      ? <div className={styles.chartWrapper} translate="no">
        <VerticalBarChart
          chartData={chartItems}
          isClickable={isClickable}
          onSelect={onSelect}
          seriesName={t('Actors')}
        />
      </div>
      : <div className={styles.noDataBreakdowns}>{t('There is no data to display')}</div>) 
      : (<div className={styles.widdgetLoader}><LoaderSmall /></div>)}
      
    </BreakdownsContainer>
  )
}

